import { render, staticRenderFns } from "./share-btn.vue?vue&type=template&id=6032dd64&scoped=true"
import script from "./share-btn.vue?vue&type=script&lang=ts"
export * from "./share-btn.vue?vue&type=script&lang=ts"
import style0 from "./share-btn.vue?vue&type=style&index=0&id=6032dd64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6032dd64",
  null
  
)

export default component.exports